import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { USER_CATEGORIES, UserCategoryType, userCategoryAdminLabel } from '@finance-lab/utils/types'
import React from 'react'

export const UserCategorySelect = ({
    onChange,
    value = '',
}: {
    onChange: (val: UserCategoryType) => void
    value: UserCategoryType | '' | null
}) => {
    return (
        <>
            <InputLabel id='user-category-label'>Kategori</InputLabel>
            <Select<UserCategoryType>
                labelId='user-category-label'
                id='user-category-select'
                name='userCategory'
                value={value || ''}
                onChange={(e) => {
                    onChange(e.target.value as UserCategoryType)
                }}
                label='Kategori'
            >
                {USER_CATEGORIES.map((category) => (
                    <MenuItem key={category} value={category}>
                        {userCategoryAdminLabel(category)}
                    </MenuItem>
                ))}
            </Select>
        </>
    )
}

export default UserCategorySelect
